export default class Constants { static DRAG_ROTATION_DEG = 5; }